import { ReactElement } from 'react';

import Spinner from './Spinner';

export function Loading({
  isLoading,
}: Readonly<{ isLoading?: boolean }>): ReactElement {
  if (!isLoading) return <></>;

  return (
    <div className="flex w-full items-center justify-center p-6">
      <Spinner />
    </div>
  );
}
